import React, { useState } from 'react';
import Styles from './styles.module.css';
import SectionTitle from './../_ui/sectionTitle';
import Step1Shot from './../../../image/landing/point/step1-input.png';
import Step2Shot from './../../../image/landing/point/step2-select.png';
import Step3Shot from './../../../image/landing/point/step3-submit.png';
import TopPageShot from './../../../image/home/point/top-page.png';
import StylePhotoShot from './../../../image/home/point/style-photo.png';
import StoreShot from './../../../image/home/point/store.png';
import PhotoShot from './../../../image/home/point/photo.png';
import RecruitShot from './../../../image/home/point/recruit.png';
import PersonaShot from './../../../image/home/point/persona.png';
import SessionShot from './../../../image/home/point/session.png';
import InterviewShot from './../../../image/home/point/interview.png';
import {
  IoCreateOutline, IoSendOutline, IoImageOutline, IoCameraOutline, IoPeopleOutline,
  IoColorPaletteOutline, IoSchoolOutline, IoDocumentTextOutline, IoMegaphoneOutline,
  IoPhonePortraitOutline, IoWalkOutline, IoChatbubbleEllipsesOutline,
  IoCheckmarkDoneOutline, IoChevronDownOutline,
} from "react-icons/io5";

/* ============================================================
   主要サービス説明を3本に集約
     01 届ける業務を変える（求人票作成・学校送付）
     02 届ける情報を変える（サロンの魅力発信）
     03 届いたあとの採用導線を変える（見学→応募→選考→採用）
   ============================================================ */

/* ---------- 01 : 3ステップのタブ切替 ---------- */
const STEPS: { tag: string; label: string; shot: string; desc: string; img?: string }[] = [
  { tag: 'STEP 1', label: '求人情報を入力', shot: '求人情報の入力画面', desc: '職種・条件・写真などをWeb上で1回入力するだけ。', img: Step1Shot },
  { tag: 'STEP 2', label: '送付する学校を選択', shot: '送付先の学校を選ぶ画面', desc: '紹介したい学校をリストから選ぶだけ。毎年の宛先管理が不要に。', img: Step2Shot },
  { tag: 'STEP 3', label: 'まとめて提出', shot: '送付内容の確認画面', desc: '送付先をまとめて確認して、一括で提出。提出・未提出の状況もひと目で分かります。', img: Step3Shot },
];

const Block01 = () => {
  const [i, setI] = useState(0);
  const s = STEPS[i];
  return (
    <section className={Styles.block}>
      <div className={Styles.head}>
        <span className={Styles.no}>01</span>
        <h3>学校ごとの求人票送付を、3ステップで。</h3>
        <p>求人情報を入力し、送りたい学校を選択。毎年繰り返していた求人票の作成・送付を、ひとつの画面から進められます。</p>
      </div>

      <div className={Styles.tabs} role="tablist" aria-label="求人票送付の3ステップ">
        {STEPS.map((t, idx) => (
          <React.Fragment key={t.tag}>
            {idx > 0 && <span className={Styles.tabArrow} aria-hidden="true">›</span>}
            <button
              type="button"
              role="tab"
              aria-selected={i === idx}
              className={`${Styles.tab} ${i === idx ? Styles.tabOn : ''}`}
              onClick={() => setI(idx)}
            >
              <span className={Styles.tabTag}>{t.tag}</span>
              <span className={Styles.tabLabel}>{t.label}</span>
            </button>
          </React.Fragment>
        ))}
      </div>

      <div className={Styles.screen}>
        <div className={Styles.screenBar}>
          <i /><i /><i />
          <span>{s.shot}</span>
        </div>
        <div className={`${Styles.screenBody} ${s.img ? Styles.screenBodyImg : ''}`} key={i}>
          {s.img ? (
            <img src={s.img} alt={s.shot} />
          ) : (
            <>
              <IoImageOutline />
              <span>{s.shot}</span>
            </>
          )}
        </div>
      </div>
      <p className={Styles.screenDesc}><strong>{s.tag}</strong>{s.desc}</p>
    </section>
  );
};

/* ---------- 02 : 中央にアプリ、周囲に情報カテゴリ ---------- */
const ORBIT: { code: string; label: string; icon: React.ReactNode; cls: string; shot: string }[] = [
  { code: 'TOP', label: 'トップページ', icon: <IoPhonePortraitOutline />, cls: 'o1', shot: TopPageShot },
  { code: 'STYLE', label: 'スタイル写真', icon: <IoColorPaletteOutline />, cls: 'o2', shot: StylePhotoShot },
  { code: 'STORE', label: '店舗紹介', icon: <IoCameraOutline />, cls: 'o3', shot: StoreShot },
  { code: 'PHOTO', label: '写真で見る', icon: <IoImageOutline />, cls: 'o4', shot: PhotoShot },
  { code: 'RECRUIT', label: '求人票', icon: <IoDocumentTextOutline />, cls: 'o5', shot: RecruitShot },
  { code: 'PERSON', label: '求める人物像', icon: <IoSchoolOutline />, cls: 'o6', shot: PersonaShot },
  { code: 'EVENT', label: '会社説明会', icon: <IoMegaphoneOutline />, cls: 'o7', shot: SessionShot },
  { code: 'INTERVIEW', label: 'インタビュー', icon: <IoPeopleOutline />, cls: 'o8', shot: InterviewShot },
];

const ALL_INFO = [
  '概要', '魅力3選', '店舗紹介', '数字で見る', '写真で見る', 'インタビュー',
  '求める人物像', '求人票', 'スタイル', '会社説明会', '施術クーポン', 'スタッフ紹介',
];

const Block02 = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const current = ORBIT[active];
  return (
    <section className={Styles.block}>
      <div className={Styles.head}>
        <span className={Styles.no}>02</span>
        <h3>求人票では伝わらない、サロンの魅力まで。</h3>
        <p>給与や休日だけでなく、スタッフ、スタイル、教育、店舗の雰囲気、会社説明会まで。美容学生がサロンを選ぶために知りたい情報を、ひとつのページで届けられます。</p>
      </div>

      <div className={Styles.orbit}>
        <div className={Styles.orbitGlow} aria-hidden="true" />
        <div className={Styles.phone}>
          <div className={Styles.phoneNotch} aria-hidden="true" />
          <div className={Styles.phoneBody} key={current.code}>
            <img src={current.shot} alt={`${current.label}のスマホ画面`} />
          </div>
        </div>
        {ORBIT.map((o, idx) => (
          <button
            key={o.code}
            type="button"
            className={`${Styles.chip} ${Styles[o.cls]} ${active === idx ? Styles.chipOn : ''}`}
            onClick={() => setActive(idx)}
            aria-pressed={active === idx}
          >
            <span className={Styles.chipIcon}>{o.icon}</span>
            <span className={Styles.chipText}>
              <b>{o.code}</b>
              {o.label}
            </span>
          </button>
        ))}
      </div>

      <button type="button" className={Styles.moreBtn} onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        掲載できる情報をすべて見る
        <IoChevronDownOutline className={open ? Styles.moreIconOpen : ''} />
      </button>
      {open && (
        <ul className={Styles.moreList}>
          {ALL_INFO.map((x) => <li key={x}>{x}</li>)}
        </ul>
      )}
    </section>
  );
};

/* ---------- 03 : 求人作成〜採用の一気通貫フロー（3フェーズ×7工程） ---------- */
const GROUPS = [
  {
    key: 'a', title: '届ける', note: '求人を作って、学校・学生へ届ける', cls: 'phaseA',
    steps: [
      { label: '求人作成', icon: <IoCreateOutline />, subs: ['求人情報を入力', '年度ごとに更新'] },
      { label: '学校送付', icon: <IoSendOutline />, subs: ['送付先を選択', '複数校へまとめて提出'] },
      { label: '学生掲載', icon: <IoPhonePortraitOutline />, subs: ['写真・スタッフを掲載', 'スタイル・説明会を掲載'] },
    ],
  },
  {
    key: 'b', title: '動いてもらう', note: '見学・応募につなげる', cls: 'phaseB',
    steps: [
      { label: '見学', icon: <IoWalkOutline />, subs: ['見学予約を受付', '日程を調整'] },
      { label: '応募', icon: <IoDocumentTextOutline />, subs: ['履歴書を受付', 'メッセージで連絡'] },
    ],
  },
  {
    key: 'c', title: '採用する', note: '応募者を管理し、選考・採用する', cls: 'phaseC',
    steps: [
      { label: '選考', icon: <IoChatbubbleEllipsesOutline />, subs: ['選考状況を管理', '面接・評価を記録'] },
      { label: '採用', icon: <IoCheckmarkDoneOutline />, subs: ['採用決定', '応募者情報を一元管理'] },
    ],
  },
];

const Block03 = () => (
  <section className={Styles.block}>
    <div className={Styles.head}>
      <span className={Styles.no}>03</span>
      <h3>求人作成から採用まで、ひとつの流れで。</h3>
      <p>求人票を作る、学校へ届ける、学生に見てもらう、見学・応募を受け付ける、選考する。新卒採用に必要な流れを、memorii works ひとつでつなげます。</p>
    </div>

    <div className={Styles.track}>
      {GROUPS.map((g) => (
        <div key={g.key} className={Styles.group}>
          <div className={`${Styles.phase} ${Styles[g.cls]}`}>
            <b>{g.title}</b>
            <span>{g.note}</span>
          </div>
          {g.steps.map((s, i) => (
            <div
              key={s.label}
              className={`${Styles.step} ${g.key === 'a' && i === 0 ? Styles.stepFirst : ''}`}
            >
              <span className={Styles.stepIcon}>{s.icon}</span>
              <span className={Styles.stepLabel}>{s.label}</span>
              {s.subs.length > 0 && (
                <ul className={Styles.stepSubs}>
                  {s.subs.map((x) => <li key={x}>{x}</li>)}
                </ul>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  </section>
);

const HomePoint = () => (
  <div className={Styles.point}>
    <SectionTitle
      pattern="B"
      title={<>その求人情報を、<br className={Styles.brsp} />そのまま学生との接点へ。</>}
      lead="求人票をつくり、学生に魅力を届け、見学から採用までつなげる。この一連を、ひとつのサービスで。"
    />
    <div className={Styles.blocks}>
      <Block01 />
      <Block02 />
      <Block03 />
    </div>
  </div>
);

export default HomePoint;
